<template>
  <Link
    v-for="category in resource.data"
    :key="category.data.id"
    :class="{ active: options.active == category.data.id }"
    :href="route(`${routePrefix}.${resourceType}.show`, { id: category.data.id })"
    class="link"
  >
    {{ category.data.attributes.name }}
  </Link>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import useResource from '@kanrisha/composables/useResource';

export default {
  components: {
    Link,
  },
  props: {
    options: { type: Object, default: () => {} },
    resource: { type: Object, default: () => {} },
    name: { type: String, default: 'default' },
    pagination: { type: Boolean, default: () => true }, // deprecated: this should go on options or config
  },
  emits: ['addToast', 'updatePicked', 'update:data', 'update:relation', 'trigger:refresh'],
  setup(props) {
    const { meta, resourceType } = useResource(props, props.resource);

    return {
      meta,
      resourceType,
    };
  },
};
</script>
